import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { QuestionBoxComponent } from '@shared/components/question-box/question-box.component';
import { AddressFormModel } from '@shared/models/forms/address-form.model';
import { countryAnswerOptions } from '@shared/models/country-registered-answer-options';
import { BundeslandOptions, Country } from '@backend/models';

@Component({
  selector: 'app-address-data',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    QuestionBoxComponent
  ],
  templateUrl: './address-data.component.html'
})
export class AddressDataComponent implements OnInit {

  @Input() form!: FormGroup<AddressFormModel>;

  private readonly destroyRef = inject(DestroyRef);

  protected readonly Country = Country;
  countryAnswerOptions = countryAnswerOptions;
  bundeslandOptions = BundeslandOptions;

  ngOnInit(): void {
    this.form.controls.country.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(country => this.applyBundeslandValidators(country));

    this.applyBundeslandValidators(this.form.controls.country.value);
  }

  setCountry(country: Country): void {
    this.form.controls.country.setValue(country);
  }

  /**
   * Bundesland is mandatory only for Austrian addresses (mirrors the backend validation).
   */
  private applyBundeslandValidators(country: Country | null): void {
    const bundesland = this.form.controls.bundesland;

    if (country === Country.Austria) {
      bundesland.addValidators(Validators.required);
    } else {
      bundesland.removeValidators(Validators.required);
      bundesland.setValue(null, { emitEvent: false });
    }

    bundesland.updateValueAndValidity({ emitEvent: false });
  }
}
